import React from 'react'

function OurServices() {
  const services = [
    {
      name: 'Direito Empresarial',
      icon: 'business',
      description:
        'Prestamos assessoria jurídica para empresas, desde a constituição até a gestão de contratos, fusões, aquisições e resolução de conflitos corporativos.',
    },
    {
      name: 'Direito Tributário',
      icon: 'gavel',
      description:
        'Oferecemos consultoria especializada para empresas e indivíduos, garantindo o cumprimento das obrigações fiscais, planejamento tributário e defesa em contenciosos fiscais.',
    },
    {
      name: 'Recuperação de Crédito',
      icon: 'account_balance',
      description:
        'Atuamos na recuperação de valores devidos, utilizando estratégias legais para reaver créditos com rapidez e eficiência, preservando seus interesses financeiros.',
    },
    {
      name: 'Direito Penal',
      icon: 'balance',
      description:
        'Defendemos os direitos dos acusados em processos criminais, com ética e compromisso, garantindo um julgamento justo e suporte em todas as etapas processuais.',
    },
    {
      name: 'Direito Civil',
      icon: 'work',
      description:
        'Abrangemos questões de direito civil, como contratos, responsabilidade civil e disputas, buscando sempre soluções eficazes e alinhadas aos interesses de nossos clientes.',
    },
    {
      name: 'Direito da Família',
      icon: 'family_restroom',
      description:
        'Oferecemos suporte em questões como divórcios, guarda de filhos, pensão alimentícia e outros temas familiares, sempre com sensibilidade e respeito às partes envolvidas.',
    },
    {
      name: 'Direito Trabalhista',
      icon: 'people_alt',
      description:
        'Representamos empregadores e empregados em disputas trabalhistas, oferecendo soluções personalizadas para resguardar os direitos e obrigações de cada parte.',
    },
    {
      name: 'Investigação Patrimonial',
      icon: 'search',
      description:
        'Realizamos investigações patrimoniais extrajudiciais para identificar bens ocultos de devedores, garantindo a proteção dos interesses de nossos clientes.',
    },
  ]

  return (
    <section className='bg-gray-100 py-12'>
      <div className='container mx-auto w-11/12 px-6 md:w-10/12'>
        <div className='text-center'>
          <h2 className='text-gray-800 mb-4 text-4xl font-bold uppercase'>Nossos Serviços</h2>
        </div>

        <div className='mt-10 grid grid-cols-1 gap-8 md:grid-cols-2'>
          {services.map((service, index) => (
            <div
              key={index}
              className='flex min-h-64 scale-100 cursor-pointer flex-col items-center justify-center bg-golden p-6 text-center shadow-lg transition-all duration-500 hover:scale-105'
            >
              <div className='w-10/12'>
                {/* Ícone */}
                <span className='material-icons text-gray-800 mb-2 text-5xl'>{service.icon}</span>

                {/* Título */}
                <h3 className='text-gray-900 mb-2 text-xl font-bold'>{service.name}</h3>

                {/* Descrição */}
                <p className='text-gray-700 text-lg'>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OurServices
